import * as React from "react";
import { PureComponentEx, translate } from "./ComponentEx";
class Collapse extends PureComponentEx {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
    }
    render() {
        const { t, children, showText, hideText } = this.props;
        const { show } = this.state;
        const classes = ["collapse-content"];
        if (!show) {
            classes.push("collapse-content-hidden");
        }
        return (React.createElement("div", { className: "collapse-container" },
            React.createElement("a", { onClick: show ? this.onHide : this.onShow }, show ? hideText || t("Hide") : showText || t("Show")),
            React.createElement("div", { className: classes.join(" ") }, children)));
    }
    onShow = () => {
        this.setState({ show: true });
    };
    onHide = () => {
        this.setState({ show: false });
    };
}
export default translate(["common"])(Collapse);
